import React from "react";

import styled from "styled-components";

import type { ApplicantSummary } from "../modals";
import { bannerDate, bannerDay } from "shared/utils/bannerDate";
import { Strip } from "./DealBanner/styled";

const NUMBER_WORDS = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"];

export const numberWord = (n: number) => NUMBER_WORDS[n] ?? String(n);

export const awaitingApplicantsMeta = (applicants: ApplicantSummary[]) => {
  const pending = applicants.filter((a) => !a.isSubmitted).length;
  const subject = `${numberWord(pending)} applicant${pending === 1 ? " in this deal has" : "s in this deal have"}`;
  return `${subject.charAt(0).toUpperCase()}${subject.slice(1)} not submitted an application yet. Screening runs once all applicants have submitted.`;
};

const Rule = styled.div`
  border-left: 3px solid #c4b58f;
  padding-left: 16px;
`;

const RuleLabel = styled.div`
  font: 600 10px "Work Sans", sans-serif;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #dcc49c;
  margin-bottom: 9px;
`;

const Lines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Line = styled.div`
  font: 300 14px/1.7 "Work Sans", sans-serif;
  color: #e7e4f2;
  b {
    font-weight: 500;
  }
`;

export interface AwaitingApplicantsStripProps {
  applicants: ApplicantSummary[];
}

export const AwaitingApplicantsStrip = ({
  applicants,
}: AwaitingApplicantsStripProps) => (
  <Strip>
    <Rule>
      <RuleLabel>Waiting on the applicant</RuleLabel>
      <Lines>
        {applicants.map(({ id, firstName, lastName, isSubmitted, submittedAt, startedAt }) => {
          const name = [firstName, lastName].filter(Boolean).join(" ") || "Applicant";
          const submitted = bannerDate(submittedAt);
          const started = bannerDay(startedAt);
          return (
            <Line key={id}>
              <b>{name}</b>
              {isSubmitted
                ? ` — submitted${submitted ? ` ${submitted}` : ""}.`
                : ` — application${started ? ` started ${started},` : ""} not submitted.`}
            </Line>
          );
        })}
      </Lines>
    </Rule>
  </Strip>
);
